<template>
<div class="main__section">
    <sidebar></sidebar>
    <div class="detailedstep">
        <div class="detailedstep__form">
              <p class="detailedstep__title">Add your company categories</p>
              <div class="detailedstep__input">
                <multiselect name="categories" id="categories" :options="getCategoriesList" label="name" track-by="id" :searchable="true" :close-on-select="true" :multiple="true" placeholder="Search categories" v-model="$v.form.categories.$model" class="input__select " :class="{ 'input__text--error': $v.form.categories.$error }">
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                </multiselect>
                <span class="detailedstep__error" v-if="$v.form.categories.$error && !$v.form.categories.required">Please select you desired categories</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="casete" v-for="(cat,index) in form.categories" :key="cat.id">
                <p>{{cat.name}}</p>
              </div>

              <div class="detailedstep__form detailedstep__form--two">
                <a href="#" class="button__next button__next--fixed text-white" @click.prevent="goBack()">Back</a>
                  <a href="#" class="button__next text-white" @click.prevent="saveData()">Next Step</a>
              </div>   
        </div>
     </div>
     <single-testimonial></single-testimonial>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapGetters, mapActions} from 'vuex';
import SingleTestimonial from '../testimonials/SingleTestimonial';
import Sidebar from '../sidebar/Sidebar';
import { required } from 'vuelidate/lib/validators';

export default {

  components:{
    'multiselect':Multiselect,
    'sidebar':Sidebar,
    'single-testimonial':SingleTestimonial
  },
  data(){
    return{
      form:{
        categories:[]
      },

    }
  },
  validations:{
      form:{
        categories:{
          required
        }
      }
  },
  methods:{
    ...mapActions([
      'saveCategories',
      'changeStep'
    ]),
    saveData(){
      this.$v.$touch();

      if(this.$v.$invalid){
          return;
      }else{
        this.saveCategories(this.form);
      }
    },
     goBack(){
        this.changeStep(3);
    }
  },
    computed:{
    ...mapGetters([
            'getCategoriesList'
        ])
    }
}
</script>

<style>

</style>